import { axiosInstance as api } from "../helpers/request";
import { IUser } from "../types/models";
import { ILoginResponse, IRegisterResponse } from "../types/response";
export interface GoogleLoginRequest {
  deviceFingerprint?: string;
  credential: string;
  nonce: string;
  password?: string;
  country?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  referrer?: string;
  landing_page?: string;
}
class AuthService {
  googleChallenge() {
    return api.get<{ clientId: string; nonce: string }>("/auth/google/challenge");
  }

  googleLogin(data: GoogleLoginRequest) {
    return api.post<ILoginResponse & { isNewUser: boolean }>("/auth/google", data);
  }

  login(data: { email: string; password: string }) {
    return api.post<ILoginResponse>("/auth/login", data);
  }

  signup(data: {
    deviceFingerprint?: string;
    email: string;
    password: string;
    country: string;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
    referrer?: string;
    landing_page?: string;
  }) {
    return api.post<IRegisterResponse>("auth/register", data);
  }

  requestResetPassword(data: { email: string }) {
    return api.post("/auth/reset-password/request", { ...data, appVersion: 3 });
  }

  submitResetPassword(data: { token: string; password: string }) {
    return api.post("/auth/reset-password/submit", data);
  }

  getMe(deferUnauthorized = false) {
    return api.get<IUser>("/auth/me", { deferUnauthorized });
  }

  submitVerifyAccount(data: { code: string }) {
    return api.post("/auth/verify", data);
  }

  resendVerifyAccount() {
    return api.post("/auth/verify/resend");
  }
}

const authServiceInstance = new AuthService();

export default authServiceInstance;
